import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "ui/components/sheet";

export default function PerformanceDetailsSidebar({
  isOpen,
  onClose,
  cardData,
}) {
  if (!cardData) return null;

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>{cardData.title}</SheetTitle>
        </SheetHeader>

        <div className="px-6 py-4 space-y-6">
          {/* Description */}
          {cardData.description && (
            <div>
              <h3 className="text-lg font-medium text-foreground mb-2">
                Calculation of {cardData.title}
              </h3>
              <p className="text-sm text-muted-foreground">{cardData.description}</p>
            </div>
          )}

          {/* Main Metric */}
          <div>
            <h3 className="text-sm font-medium text-muted-foreground mb-2">
              Current Value
            </h3>
            <div className="text-2xl font-bold text-primary">
              {cardData.value} {cardData.unit}
            </div>
          </div>

          {/* Additional Details */}
          {cardData.details && (


            <div className="space-y-2 grid grid-cols-2 gap-2">
              {cardData.details.map((detail, index) => (
                <div key={index} className="flex flex-col text-sm">
                  <span className="text-muted-foreground">
                    {detail.label}
                  </span>
                  <span className="font-medium">{detail.value}</span>
                </div>
              ))}

            </div>
          )}

          {/* Chart Data */}
          {cardData.chartData && (
            <div>
              <h3 className="text-sm font-medium text-muted-foreground mb-2">
                Chart Information
              </h3>
              <div className="space-y-2">
                {cardData.chartData.map((data, index) => (
                  <div key={index} className="flex justify-between text-sm">
                    <span className="text-muted-foreground">{data.label}:</span>
                    <span className="font-medium">{data.value}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
